import { PROVINCES, SERVICES_KEYS } from "appLauncher";
import styled from "styled-components";
import { SectionTitle, SectionSubtitle } from "components/Style";
const ANIMATION_DURATION = 16; // 动画速度，越小越快

const NewsImagePlaceholder = styled.div`
  width: 503px;
  height: 319px;
  background-image: url(/assets/home/image-2.png);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b0b0b0;
  font-size: 20px;
  margin: 0 auto;
`;
const NewsSection = styled.section`
  padding: 68px 0;
  background-color: #fff;
  overflow: hidden;
`;

const NewsContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
`;

const NewsContent = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 57px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const NewsList = styled.ul`
  list-style: none;
  flex: 1;
  margin-left: 42px;
  width: 100%;
  overflow: hidden;
  padding-right: 8px;

  will-change: transform;
  animation: scroll-up linear infinite;
  animation-duration: ${ANIMATION_DURATION}s;
  @keyframes scroll-up {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-50%);
    }
  }
  @media (max-width: 768px) {
    margin-left: 0;
    margin-top: 20px;
    max-width: 100%;
    width: 100%;
    max-height: none;
    overflow: visible;
    padding-right: 0;
  }
`;

const NewsItem = styled.li`
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  min-height: 38px;
  display: flex;
  align-items: flex-start;
  &::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #1a4ffe;
    border-radius: 50%;
    margin-right: 12px;
    margin-top: 14px;
    flex-shrink: 0;
  }
`;

const NewsText = styled.span`
  color: #333;
  font-size: 16px;
`;

const NewsListOuter = styled.div`
  flex: 1;
  overflow: hidden;
  height: 280px;
  width: 500px;
  box-sizing: border-box;
  @media (max-width: 768px) {
    flex: auto;
    margin-top: 20px;
  }
`;
// 生成自动化动态数据
function getRandomNewsList(count = 6) {
  const arr = [];
  for (let i = 0; i < count; i++) {
    const province = PROVINCES[Math.floor(Math.random() * PROVINCES.length)];
    const type =
      SERVICES_KEYS[Math.floor(Math.random() * SERVICES_KEYS.length)];
    const starLen = Math.floor(Math.random() * 5) + 2; // 2~6位
    const stars = "*".repeat(starLen);
    arr.push(`${province}${stars}公司成功开出${type}`);
  }
  return arr;
}
const NEWS_ORIGIN = getRandomNewsList(20);
const ALL_NEWS = [...NEWS_ORIGIN, ...NEWS_ORIGIN]; // 渲染两倍数据用于无缝滚动

export default function News() {
  return (
    <NewsSection>
      <NewsContainer>
        <SectionTitle>业务动态</SectionTitle>
        <SectionSubtitle>Business Dynamics</SectionSubtitle>
        <NewsContent>
          <NewsImagePlaceholder></NewsImagePlaceholder>
          <NewsListOuter>
            <NewsList>
              {ALL_NEWS.map((text, idx) => (
                <NewsItem key={idx}>
                  <NewsText>{text}</NewsText>
                </NewsItem>
              ))}
            </NewsList>
          </NewsListOuter>
        </NewsContent>
      </NewsContainer>
    </NewsSection>
  );
}
